"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLogoLeft(props) {
    return (React.createElement("svg", __assign({ width: 170, height: 302, viewBox: "0 0 170 302", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M5.095 32.35l106.067 105.642a18.598 18.598 0 015.431 13.129c0 4.918-1.952 9.637-5.431 13.128L5.095 269.865a13.552 13.552 0 00-2.953 4.398 13.505 13.505 0 000 10.377 13.556 13.556 0 002.953 4.399l8.023 7.989A13.63 13.63 0 0022.746 301a13.63 13.63 0 009.628-3.972l129.522-128.97a24.118 24.118 0 005.258-7.825 24.007 24.007 0 000-18.465 24.114 24.114 0 00-5.258-7.824L32.374 4.974a13.65 13.65 0 00-5.246-3.25 13.695 13.695 0 00-6.147-.611 14.57 14.57 0 00-8.238 4.234l-7.755 7.75a13.524 13.524 0 00-2.966 4.425A13.478 13.478 0 005.095 32.35v0z", fill: "#fff", stroke: "#fff" })));
}
exports.default = SvgLogoLeft;
//# sourceMappingURL=LogoLeft.js.map